import { addDays, format, subMonths } from "date-fns";
import { ActionStatisticsDashboardActionType, PatientFilterStateActions, PatientManufacturerFilterStart } from "./types";



export const initialState: PatientManufacturerFilterStart = {
  start_date: format(subMonths(new Date(), 2), 'yyyy-MM-dd'),
  end_date: format(addDays(new Date(), 1), 'yyyy-MM-dd'),
  case_id: "",
  global_patient_id: "",
  global_doctor_id: "",
  practice_id: "",
  ref_user:"",
  search_str:"",
  global_patient_external_id:"",
  role:"",
  id:"",
  treatable_page: 1,
  todo_page: 1,
  sp_treatment_page: 1,
  not_treated_page: 1,
};

export const tableFilterReducer = (state: PatientManufacturerFilterStart, action: ActionStatisticsDashboardActionType): PatientManufacturerFilterStart => {
  switch (action.type) {
    case PatientFilterStateActions.SET_QUERY_PARAMS:
      return {
        ...state,
        ...action.payload,
      };

    case PatientFilterStateActions.SET_REF_USER:
      return {
        ...state,
        ref_user: action.payload,
      };

    case PatientFilterStateActions.CHANGE_TREATABLE_PAGE:
      return {
        ...state,
        treatable_page: action.payload
      };

    case PatientFilterStateActions.CHANGE_TODO_PAGE:
      return {
        ...state,
        todo_page: action.payload,
      };

    case PatientFilterStateActions.CHANGE_SP_TREATMENT_PAGE:
      return {
        ...state,
        sp_treatment_page: action.payload,
      };

    case PatientFilterStateActions.CHANGE_NOT_TREATED_PAGE:
      return {
        ...state,
        not_treated_page: action.payload,
      };
    case PatientFilterStateActions.CHANGE_USER_ROLE_AND_ID:
      return {
        ...state,
        role: action.payload.role,
        id: action.payload.id,
        ref_user: action.payload.ref_user,
      };
    case PatientFilterStateActions.RESET_FILTERS:
      return {
        ...initialState,
        ...action.payload
      };

    default:
      return state;
  }
};
